import React from 'react';
import { mapDropdownOptionToRHFSelectOption, RHFSelect } from '@/Components/shadcn/rhf-select';
import UIStrings from '@/Utils/UIStrings';
import workArrangementOptions from '../WorkArrangementOptions';
import { JobDetailsFieldTypes } from '../../JobDetailsStepUtils';

const workArrangementSelectOptions = workArrangementOptions.map(mapDropdownOptionToRHFSelectOption);

function WorkArrangement(): React.JSX.Element {
    return (
        <div className="w-36 shrink-0">
            <RHFSelect
                label={`${UIStrings.WorkArrangement}*`}
                name={JobDetailsFieldTypes.WorkArrangement}
                options={workArrangementSelectOptions}
                fieldDataCy={JobDetailsFieldTypes.WorkArrangement}
            />
        </div>
    );
}

export default WorkArrangement;
